import {
  BaseService,
  Status,
  DataResponse,
  MessageResponse,
  MessageData,
} from './base.service';
import { UserLabel } from '@/models/label.model';

class LabelsService extends BaseService {
  private url: string = '/api/user-label';

  constructor() {
    super();
  }

  public async create(
    label: Partial<UserLabel>,
  ): Promise<DataResponse<UserLabel>> {
    const res = await this.$http.post<UserLabel>(this.url, label);

    return {
      status: [Status.Ok, Status.Created].includes(res.status),
      data: res.data,
    };
  }

  public async edit(label: UserLabel): Promise<DataResponse<UserLabel>> {
    const res = await this.$http.put<UserLabel>(
      `${this.url}/${label.id}`,
      label,
    );

    return {
      status: res.status === Status.Ok,
      data: res.data,
    };
  }

  public async getList(): Promise<DataResponse<UserLabel[]>> {
    const res = await this.$http.get<UserLabel[]>(`${this.url}`);
    return {
      status: res.status === Status.Ok,
      data: res.data,
    };
  }

  public async delete(id: number): Promise<MessageResponse> {
    const res = await this.$http.delete<MessageData>(`${this.url}/${id}`);

    return {
      status: res.status === Status.Ok,
      message: res.data.message,
    };
  }
}

export default new LabelsService();
